import React from "react";
import {
  Link,
  useRouteMatch,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import AutoriaForm from "./AutoraForm";
import AutoriaFilledData from "./AutoriaFilledData";
import { SearchInput } from "../../SearchInput";
import AutoriaList from "./AutoriaList";
import { useTranslation } from "react-i18next";
function AutoriaMainLayout() {
  const { path } = useRouteMatch();
  const [search, setSearch] = React.useState("");
  React.useEffect(() => {
    console.log(path);
  }, [path]);
  React.useEffect(() => {
    console.log(search);
  }, [search]);
  const { t } = useTranslation();
  return (
    <div>
      <Switch>
        <Route
          path={[`${path}`, `${path}/created`, `${path}/in-process`]}
          exact
        >
          <div className="autoriaMainLayout">
            <div className="d-flex">
              <SearchInput
                placeholder={t("services.copyright.search")}
                className={`SearchInput--autoria`}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <Link
                to={`${path}/create`}
                className="text-no-wrap btn btn-accent-100 btn-sm button"
              >
                {t("services.copyright.form.buttons.1")}
              </Link>
            </div>

            <AutoriaList path={path} search={search} />
          </div>
        </Route>
        <Route path={`${path}/create`}>
          <AutoriaForm />
          {/* <AutoriaFilledData /> */}
        </Route>
        <Route path={`${path}/:elementID/edit`}>
          <AutoriaForm />
        </Route>
      </Switch>
    </div>
  );
}

export default AutoriaMainLayout;
